/**
 * Modal Auto-Open Prevention Script
 * Prevents modals from opening automatically on page load
 * Removes any 'open' attribute that may have been set incorrectly
 */

(function() {
  'use strict';
  
  console.log('[Modal Prevention] Initializing...');
  
  /**
   * Remove open attribute from all modals on page load
   */
  function preventAutoOpen() {
    const allModals = document.querySelectorAll('modal-dialog');
    
    if (allModals.length === 0) {
      console.log('[Modal Prevention] No modals found on page');
      return;
    }
    
    console.log('[Modal Prevention] Found', allModals.length, 'modals');
    
    allModals.forEach((modal, index) => {
      const modalId = modal.getAttribute('id');
      const hasOpen = modal.hasAttribute('open');
      const hasDelay = modal.dataset.delay;
      const hasPopup = modal.dataset.popup;
      
      // Skip modals that are intentionally meant to auto-open
      if (hasDelay || hasPopup) {
        console.log(`[Modal Prevention] Modal ${index + 1} (${modalId}) has delay/popup, allowing auto-open`);
        return;
      }
      
      // Remove open attribute if present
      if (hasOpen) {
        modal.removeAttribute('open');
        console.warn(`[Modal Prevention] Removed 'open' from modal ${index + 1} (${modalId})`);
      }
    });
  }
  
  /**
   * Watch for modals being added with open attribute
   * ONLY watches for new nodes, NOT attribute changes to avoid infinite loops
   */
  function watchForAutoOpenModals() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.tagName === 'MODAL-DIALOG') {
            // Check if it has open attribute but no delay/popup
            if (node.hasAttribute('open') && !node.dataset.delay && !node.dataset.popup) {
              console.warn('[Modal Prevention] Detected modal added with open attribute:', node.id);
              // Use setTimeout to avoid triggering observer during mutation
              setTimeout(() => {
                node.removeAttribute('open');
              }, 0);
            }
          }
        });
      });
    });
    
    // IMPORTANT: Only observe childList, NOT attributes
    // Observing 'attributes' would create infinite loop when we remove 'open'
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('[Modal Prevention] Watching for new modals (childList only)');
  }
  
  /**
   * Main initialization
   */
  function init() {
    preventAutoOpen();
    watchForAutoOpenModals();
    console.log('[Modal Prevention] Complete');
  }
  
  // Run as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Expose for debugging
  window.__modalPrevention = {
    preventAutoOpen,
    version: '1.0.0'
  };
  
})();

